import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { destroyAdminAction } from '../../../reducers/admin';
import { loadDevSettingsAction } from '../../../reducers/devSetting';

import { useFormData } from '../../../hook';
import useCheckboxForm from '../../../hook/UseCheckboxForm';

import UIKit from "../../../Components/UIKit";
import Pagination from "../Pagination";
import Loader  from '../Loader';
import HeaderDetailOptions from '../HeaderDetailOptions'

const TableStyle = () => {
    const dispatch = useDispatch();
    const {
        devSettings,
        loadDevSettingsLoading,
        loadDevSettingsDone,
        loadDevSettingError,
        destroyDevSettingDone,
        destroyDevSetting,
    } = useSelector((state) => state.devSetting);

    const [isShowDetailOptions, setIsShowDetailOptions] = useState(false);

    const checkboxForm =  useCheckboxForm(null);
    const history = useHistory();
    const location = useLocation();

    const locationSearch = location.search;
    const parsedLocationSearch = queryString.parse(locationSearch);

    let defaultColumn = '';
    if(parsedLocationSearch.sort) {
        defaultColumn = JSON.parse(atob(parsedLocationSearch.sort));
        defaultColumn = Object.keys(defaultColumn)[0];
    }

    const sortForm = useFormData({
        column: defaultColumn ? defaultColumn :'regdate',
        sort: 'desc'
    });


    useEffect(() => {
        let query = location.search;
        dispatch(loadDevSettingsAction(query));
    }, [location, destroyDevSettingDone]);

    useEffect(() => {
        if(loadDevSettingError) {

        }
    }, [loadDevSettingError]);

    useEffect(() => {
        if(loadDevSettingsDone) {
            checkboxForm.init(devSettings);
        }
    }, [loadDevSettingsDone]);

    useEffect(() => {
        if(checkboxForm && checkboxForm.value) {
            if(checkboxForm.value.total.checked) {
                setIsShowDetailOptions(true);
                return;
            }

            const keys = Object.keys(checkboxForm.value);
            for(let key of keys) {
                if(key !== 'total' && key !== 'isShowDetailOption') {
                    if(checkboxForm.value[key].checked) {
                        setIsShowDetailOptions(true);
                        return;
                    }
                }
            }
            setIsShowDetailOptions(false);
        }
    }, [checkboxForm.value]);

    const onClickDetail = useCallback((seq) => {
        history.push(`/setting/devSetting/all/${seq}`);
    }, []);

    const onClickColumn = useCallback((clickedColumn) => {
        let sort = {};
        let sortQuery = '';
        if (sortForm.value.column !== clickedColumn) {
            sortForm.onChange({column : clickedColumn, sort: 'desc'});
            sort[clickedColumn] = 'desc';
            sort = JSON.stringify(sort);
            sortQuery = `sort=${btoa(sort)}`;
        } else {
            sortForm.onChange({
                sort: sortForm.value.sort === 'desc' ? 'asc' : 'desc'
            });
            sort[clickedColumn] = sortForm.value.sort === 'desc' ? 'asc' : 'desc';
            sort = JSON.stringify(sort);
            sortQuery = `sort=${btoa(sort)}`;
        }

        let nextQueryString = sortQuery;
        if(location.search) {
            let nowQueryStringObj = queryString.parse(location.search);
            delete nowQueryStringObj.sort;
            if(decodeURIComponent(queryString.stringify(nowQueryStringObj))) {
                nextQueryString = `${decodeURIComponent(queryString.stringify(nowQueryStringObj))}&${sortQuery}`;
            }
        }

        history.push({
            pathname: location.pathname,
            search: nextQueryString
        });
    }, [history, location, sortForm]);

    useEffect(() => {
        if(destroyDevSettingDone) {
            alert(destroyDevSetting.data.msg);
            setIsShowDetailOptions(false);
            checkboxForm.remove(destroyDevSetting.devSettingSeq);
        }
    }, [destroyDevSettingDone]);

    return loadDevSettingsLoading ? (
        <div>
            <Loader />
        </div>
    ) : loadDevSettingsDone && (
        <div>
            {
                checkboxForm && checkboxForm.value && isShowDetailOptions && (
                    <HeaderDetailOptions
                        checkboxForm={checkboxForm}
                        destroyModelAction={destroyAdminAction}
                    />
                )
            }

            <UIKit.Card
                title={""}
                cardOptions={"uk-card-default uk-card-style uk-margin-medium-top uk-text-0_8"}
                cardBodyOptions={"uk-padding-remove-top"}
            >

                    <div>
                        <span className="uk-padding-12-left uk-margin-top">
                            <span className="uk-hidden@m uk-padding-xsmall-right">
                                <input type="checkbox" className="uk-checkbox" />
                            </span>
                            <span>총 {devSettings.total}건</span>
                        </span>
                        <div className='uk-overflow-auto'>
                            <table className="uk-table uk-table-pointer uk-table-small uk-table-hover uk-table-divider uk-table-middle">
                                <thead className="uk-text-center">
                                    <tr>
                                        <th className="uk-table-shrink">
                                            {
                                                checkboxForm && checkboxForm.value && (
                                                    <input
                                                        className="uk-checkbox"
                                                        type="checkbox"
                                                        checked={checkboxForm.value.total.checked}
                                                        onChange={checkboxForm.onChangeCheckboxAll}
                                                    />
                                                )
                                            }

                                        </th>
                                        <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('domain')}>
                                            <span>도메인</span>
                                            {sortForm.value.column === 'domain' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                                        </th>
                                        <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('brand_seq')}>
                                            <span>브랜드</span>
                                            {sortForm.value.column === 'brand_seq' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                                        </th>
                                        <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('regdate')}>
                                            <span>등록일</span>
                                            {sortForm.value.column === 'regdate' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        devSettings && devSettings.data.map((devSetting) => (
                                            <tr key={devSetting.seq}>
                                                <td>
                                                    {
                                                        checkboxForm && checkboxForm.value && checkboxForm.value[devSetting.seq] && (
                                                            <input
                                                                className="uk-checkbox"
                                                                type="checkbox"
                                                                checked={checkboxForm.value[devSetting.seq].checked}
                                                                onChange={() => checkboxForm.onChangeCheckbox(devSetting.seq)}
                                                            />
                                                        )
                                                    }


                                                </td>
                                                <td
                                                    className="uk-text-center"
                                                    onClick={() => onClickDetail(devSetting.seq)}
                                                >
                                                    {devSetting.domain}
                                                </td>
                                                <td
                                                    className="uk-text-center"
                                                    onClick={() => onClickDetail(devSetting.seq)}
                                                >
                                                    {devSetting.brand_seq}
                                                </td>
                                                <td
                                                    className="uk-text-center"
                                                    onClick={() => onClickDetail(devSetting.seq)}
                                                >
                                                    {devSetting.regdate}
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <Pagination
                                currentPage={devSettings.current_page}
                                pageLast={devSettings.last_page}
                            />
                        </div>
                    </div>
            </UIKit.Card>
        </div>
    )
};

export default TableStyle;
